import { ValidationObserver, ValidationProvider } from "vee-validate";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import firebase from 'firebase';
import { getRegionName } from '@/utils/functionsRegion';
import { relationshipTypes } from '@/consts/relationship-types';
import { FamilyHubAppStatus } from '@/enums/FamilyHubAppStatus';
import * as Sentry from "@sentry/vue"; 
import { toBoolean } from "@/utils/toBoolean";

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        ConfirmDlg
    },
    props: {
        value: Boolean,
        residentId: String,
        familyListView: String
    },
    data() {
        return {
            name: '',
            email: '',
            phoneNumber: '',
            isFinancialEPOA: false,
            isEnduringPOA: false,
            isWelfarePOA: false,
            financialEPOA: [],
            enduringPOA: [],
            welfarePOA: [],
            invitedToFamilyApp: false,
            isCanInvite: false,
            residentConsent: false,
            circleOfSupport: '',
            relationship: '',
            isManual: true,
            submited: false,
            members: [],
            csv: null,
            csvData: null,
            filename: null,
            errorContent: "",
            errorHeaders: "",
            errorValues: "",
            errorEmails: "",
            isError: false,
            selectedResident: null,
            csvHeaders: {
                residentName: 'Resident',
                familyMemberName: 'Name',
                familyMemberNameEmail: 'Email',
                relationship: 'Relationship',
                phoneNumber: 'Phone number (optional)',
                addToApp: 'Add as User to Family App TRUE / FALSE',
                epoa: 'Financial POA (FPOA) TRUE / FALSE',
                isWelfarePOA : 'Welfare POA (WPOA) TRUE / FALSE',
                isEnduringPOA: 'Enduring POA (EPOA) TRUE / FALSE',
                isCanInvite: 'Can invite family members TRUE / FALSE',
                residentConsent: 'Resident consents to their information being shared TRUE / FALSE',
                careSummary: 'Care Summary TRUE / FALSE',
                dailyCare: 'Daily Care TRUE / FALSE',
                dailyPlan: 'Daily Plan TRUE / FALSE',
                carePlan: 'Care Plan TRUE / FALSE',
                concierge: 'Concierge TRUE / FALSE',
                instantCalls: 'Instant Calls TRUE / FALSE',
                scheduledCalls: 'Scheduled Calls TRUE / FALSE',
                chat: 'Chat TRUE / FALSE'
            },
            staffControlledFamilyAccesses: {
                activities:  true,
                care: this.$store.state.facilityModule.selectedFacility?.isEnableCareTab ?? false,
                careNotes:  false,
                careSummary:  (this.$store.state.facilityModule.selectedFacility?.isCareSummary ?? false),
                chat:  true,
                concierge:  true,
                conciergeEvents:  true,
                dailyCare: (this.$store.state.facilityModule.selectedFacility?.isDailyCare ?? false),
                dailyPlan: (this.$store.state.facilityModule.selectedFacility?.isDailyPlan ?? false),
                carePlan: ((this.$store.state.facilityModule.selectedFacility?.isCarePlan && this.$store.state.facilityModule.selectedFacility?.isEnabledCarePlan) ?? false),
                instantCalls:  true,
                lifestyle: true,
                lifestyleEvents:  true,
                noticeboard: true,
                scheduledCalls: true,
            },
            baseTemplateUrl: "https://firebasestorage.googleapis.com/v0/b/reshub-test.appspot.com/o/csv-templates%2FTemplate%20family%20upload%20csv%20-%20Sheet6.csv?alt=media&token=1b51308e-48d9-4815-8429-360b5fb96cdb",
            invalidHeaders: [],
            missingFields: [],
            emailDuplicates: [],
            dataIsMapped: false,
            loadedFileName: '',
            dataIsLoading: false
        }
    },
    watch: {
        open(isOpen) {
            if (isOpen) {
                if (this.residentId) {
                    this.$store.dispatch('getResident', this.residentId)
                }
            }
        },

    },
    computed: {
        facility() {
            return this.$store.state.facilityModule.selectedFacility;
        },
        facilityOrgId() {
            return this.$store.state.facilityModule.selectedFacility.orgId;
        },
        facilityMailingLists() {
            return this.$store.state.facilityModule.facilityMailingLists;
        },
        facilityEmailTemplateTypes() {
            return this.$store.state.facilityModule.facilityEmailTemplateTypes;
        },
        emailTemplateTypeRule() {
            return this.$store.state.businessRulesModule.rule;
        },
        residents() {
            return this.$store.state.residentModule.residentsShortData;
        },
        open: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            }
        },
        relationshipTypes() {
            return relationshipTypes;
        }
    },
    created() {
        this.$store.dispatch("getFacilityMailingLists")

        if(this.isEnduringPOA
            && this.$store.state.facilityModule.selectedFacility?.isEnableCareTab === true 
            && this.$store.state.facilityModule.selectedFacility?.isEnabledCarePlan){
            this.staffControlledFamilyAccesses.care = true
            this.staffControlledFamilyAccesses.carePlan = true
        }
        else{
            this.staffControlledFamilyAccesses.carePlan = false
        }
    },
    methods: {

        async addFamilyHubUser() {

            await (this.$refs.observer).validate();

            if(this.familyListView){
                const result = await (this.$refs.confirmationModal).open(null, `
                ${(this.$i18n.messages[this.$i18n.locale]['AddFamilyMemberDialog.AddMemberAsResidentsRelationshipType'] as string).
                  replace('[memberName]',this.name).replace('[residentName]',this.selectedResident.name)} ${this.relationship == 'Other'?
                    this.$i18n.messages[this.$i18n.locale]['AddFamilyMemberDialog.UnknownRelationship']: this.relationship}`,
                  false, '', { noButtonText:this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Cancel'], yesButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Save']})
                if (!result || !result.agree) return
            }

            if(!this.selectedResident){
                this.selectResident()
            }

            this.submited = true;

            try {
                const newFamilyHubUser = {
                    name: this.name,
                    email: this.email.toLowerCase(),
                    phoneNumber: this.phoneNumber,
                    financialEPOA: this.financialEPOA,
                    enduringPOA: this.enduringPOA,
                    welfarePOA: this.welfarePOA,
                    relationship: this.relationship,
                    invitedToFamilyApp: this.invitedToFamilyApp,
                    isCanInvite: this.isCanInvite,
                    familyAccesses : this.staffControlledFamilyAccesses,
                    staffControlledFamilyAccesses: this.staffControlledFamilyAccesses,
                    residentConsent: this.residentConsent
                };

                const response = await firebase.app().functions(getRegionName())
                  .httpsCallable('familyUser-findFamilyUserResident')({
                      familyHubUserEmail: this.email.toLowerCase(),
                      residentId: null,
                      orgId: this.facilityOrgId
                  });

                const existingResidents = response.data?.data;

                if (existingResidents && existingResidents.length > 0) {

                    if(existingResidents.find(x => x.id === this.$route.params.id)) {
                        this.$refs.observer.setErrors({Email: [this.$i18n.messages[this.$i18n.locale]['AddFamilyMemberDialog.ResidentAlreadyHasAFamilyMemberWithThisEmail']]});
                        this.submited = false;
                        return false;
                    }

                    const names = existingResidents.map(x => x.name).join(', ');
                    const result = await (this.$refs.confirmationModal).open(null, this.$i18n.messages[this.$i18n.locale]['AddFamilyMemberDialog.FamilyMemberAlreadyAttachedToResident'].replace('[names]',names), false);

                    if (result && result.agree) {
                        this.$store.dispatch('addFamilyHubUser', {familyHubUser: newFamilyHubUser, residentId: this.residentId}).then(async ()=>{
                            this.$emit("familyMembersAdded");
                            this.$toast.open({ message: this.$i18n.messages[this.$i18n.locale]['AddFamilyMemberDialog.FamilyMemberSuccessfullAadded'], type: "success" });
                            this.close()
                        }).catch((error) => {
                            this.$toast.open({ message: `${error.message}`, type: "success" });
                        }).finally(() => {
                            this.submited = false;
                        })
                    }
                } else {
                    this.$store.dispatch('addFamilyHubUser', {familyHubUser: newFamilyHubUser, residentId: this.residentId}).then(async ()=>{
                        this.$emit('familyMembersAdded')
                        this.$toast.open({ message: this.$i18n.messages[this.$i18n.locale]['AddFamilyMemberDialog.FamilyMemberSuccessfullAadded'], type: "success" });
                        this.close()
                    }).catch((error) => {
                        this.$toast.open({ message: `${error.message}`, type: "success" });
                    }).finally(() => {
                        this.submited = false;
                    })
                }
            } catch (error) {
                console.error(error)
                this.submited = false;
            }
        },

        async importData() {
            try {
                this.submited = true;

                const promises = this.members.map(member =>
                  this.$store.dispatch('importFamilyHubUser', member)
                    .catch(error => {
                        console.error(`Failed to import member ${member.id}:`, error);
                        return false;
                    })
                );

                const results = await Promise.all(promises);

                const addedMembersLength = results.filter(result => result === true).length;

                this.$toast.open({
                    message: this.$i18n.messages[this.$i18n.locale]['AddFamilyMemberDialog.ImportedFamilyMembers']
                      .replace('[count]', addedMembersLength),
                    type: "success",
                });

                await this.$emit("familyMembersAdded");
            } catch (error) {
                console.error("Error during import:", error);
                this.$toast.open({
                    message: this.$i18n.messages[this.$i18n.locale]['AddFamilyMemberDialog.UnableToImportMembers'],
                    type: "error",
                });
            } finally {
                this.submited = false;
                this.csv = null;
                this.csvData = null;
                this.close();
            }
        },

        async mapCsvDataToObjects(csvData) {
            this.dataIsMapped = false;
            const members = []
            const facility = this.$store.state.facilityModule.selectedFacility;

            for (const raw of csvData) {

                const member: any = {
                    facilityId: this.$store.state.authModule.currentFacility,
                    isFromCsv: true,
                    csvFileName: this.csvFileName
                }

                const rawValues = this.getRawValues(raw);
                // TODO: Optimize to batch Firestore requests instead of performing sequential queries 
                const residents = await firebase.firestore().collection("residents").where("name", "==", rawValues.residentName).where("facilityId", "==", member.facilityId).get()

                if (residents.empty) {
                    this.setErrorContent(`<b>${rawValues.residentName}</b> - resident does not exist`)
                    console.log(`${rawValues.residentName} - resident does not exist`)
                }
                else {
                    const resident = { id: residents.docs[0].id, ...residents.docs[0].data() };
                    member.name = rawValues.familyMemberName;
                    member.email = rawValues.familyMemberNameEmail;
                    member.phoneNumber = rawValues.phoneNumber;
                    member.relationship = rawValues.relationship;
                    member.residentId = resident.id;
                    member.residentIds = [resident.id];
                    member.residents = [{ id: resident.id, name: rawValues.residentName }];
                    member.residentName = rawValues.residentName;

                    const isFinancialEPOA = toBoolean(rawValues.epoa)
                    const isEnduringPOA = toBoolean(rawValues.isEnduringPOA)
                    const isWelfarePOA = toBoolean(rawValues.isWelfarePOA)

                    member.financialEPOA = [{ id: resident.id, status: isFinancialEPOA }]
                    member.enduringPOA = [{ id: resident.id, status: isEnduringPOA }]
                    member.welfarePOA = [{ id: resident.id, status: isWelfarePOA }]

                    member.invitedToFamilyApp = rawValues.addToApp;
                    member.isCanInvite = rawValues.isCanInvite;
                    member.residentConsentCheckbox = Boolean(rawValues.residentConsent);

                    const familyAppAccess = { ...this.staffControlledFamilyAccesses };

                    familyAppAccess.careSummary = rawValues.careSummary ?? false;
                    familyAppAccess.dailyCare = rawValues.dailyCare ?? false;
                    familyAppAccess.dailyPlan = rawValues.dailyPlan ?? false;
                    familyAppAccess.carePlan = rawValues.carePlan ?? false;
                    
                    familyAppAccess.care = Boolean(familyAppAccess.careSummary || familyAppAccess.dailyCare || familyAppAccess.dailyPlan || familyAppAccess.carePlan);

                    familyAppAccess.concierge = rawValues.concierge ?? false;
                    familyAppAccess.instantCalls = rawValues.instantCalls ?? false;
                    familyAppAccess.scheduledCalls = rawValues.scheduledCalls ?? false;
                    familyAppAccess.chat = rawValues.chat ?? false;

                    familyAppAccess.carePlan = Boolean(
                        isEnduringPOA &&
                        facility?.isEnableCareTab &&
                        facility?.isEnabledCarePlan &&
                        familyAppAccess.care &&
                        familyAppAccess.carePlan
                    );
                 
                    member.staffControlledFamilyAccesses = familyAppAccess;
                    member.familyAccesses = { ...familyAppAccess };

                    if (rawValues.addToApp === true) {
                        member.appStatus = FamilyHubAppStatus.Pending;
                    } else {
                        member.appStatus = FamilyHubAppStatus.NotAdded;
                    }

                    members.push(member);
                }
            }

            this.dataIsMapped = true;
            return members
        },

        onLoadFile(e) {
            this.dataIsLoading = true;

            if (!e || !e.currentTarget || !this.$papa || !this.$papa.parse) return

            const file = e.currentTarget.files[0]

            this.loadedFileName = file.name

            this.$papa.parse(file, {
                header: true,
                complete: this.onComplete,
                skipEmptyLines: true,
            })
        },

        async onComplete(results, file) {
            try {
                this.clearError()

                if (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel") {
                    const message = this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.PleaseUploadaCSVFile'];
                    this.setErrorContent(message)
                    return false;
                }
                
                if (!this.isCsvDataValid(results)) {
                    if (this.invalidHeaders.length > 0) {
                        const invalidHeadersMessage = this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.MissingHeaders'] + `: ${this.invalidHeaders.join(', ')}`
                        this.setErrorHeaders(invalidHeadersMessage)
                    }
                    if (this.missingFields.length > 0) {
                        const invalidValuesMessage = this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.MissingMandatoryFields'] + `: ${this.missingFields.join(', ')}`
                        this.setErrorValues(invalidValuesMessage)
                    }
                    if (this.emailDuplicates.length > 0) {
                        const invalidEmailsMessage = `Emails duplicates in rows: ${this.emailDuplicates.map(index => index + 1).join(', ')}`
                        this.setErrorEmails(invalidEmailsMessage)
                    }

                    return false;
                }

                this.csv = results;
                this.csvData = results.data
                this.csvFileName = file.name

                this.members = await this.mapCsvDataToObjects(this.csvData)
                this.filename = this.loadedFileName;
            }
            finally {
                this.dataIsLoading = false;
            }
        },

        isCsvDataValid(results) {

            const isHeadersValid = this.isHeadersValid(results);
            const isMandatoryFieldsPopulated = this.isMandatoryFieldsPopulated(results);
            const isNoEmailsDuplicates = this.isNoEmailsDuplicates(results);

            return isHeadersValid && isMandatoryFieldsPopulated && isNoEmailsDuplicates;
        },

        isHeadersValid(results) {
            const requiredHeaders = [
                this.csvHeaders.residentName,
                this.csvHeaders.familyMemberName,
                this.csvHeaders.familyMemberNameEmail,
                this.csvHeaders.relationship,
                this.csvHeaders.phoneNumber,
                this.csvHeaders.addToApp,
                this.csvHeaders.epoa,
                this.csvHeaders.isEnduringPOA,
                this.csvHeaders.isWelfarePOA,
                this.csvHeaders.isCanInvite
            ];

            const missingHeaders = requiredHeaders.filter(
              requiredHeader => !results.meta.fields.some(field => field.includes(requiredHeader))
            );

            const isHeadersValid = missingHeaders.length === 0;

            if (!isHeadersValid) {
                Sentry.captureMessage(`Headers invalid. Missing headers: ${missingHeaders.join(', ')}`);
                Sentry.captureMessage(`Facility: ${this.facility.id} - ${this.facility.name}`);
                this.invalidHeaders = missingHeaders;
            }

            return isHeadersValid;
        },

        isMandatoryFieldsPopulated(results) {
            return !results.data.some((raw) => {
                const rawValues = this.getRawValues(raw);

                const mandatoryFields = [
                    { label: 'Resident Name', value: rawValues.residentName },
                    { label: 'Family Member Name', value: rawValues.familyMemberName },
                    { label: 'Family Member Email', value: rawValues.familyMemberNameEmail },
                    { label: 'Add as User to Family App', value: rawValues.addToApp },
                    { label: 'Financial POA (FPOA)', value: rawValues.epoa },
                    { label: 'Can invite family members', value: rawValues.isCanInvite },
                ];

                const missingFields = mandatoryFields
                  .filter(field => field.value === undefined || field.value === null || field.value === '')
                  .map(field => field.label);

                if (missingFields.length > 0) {
                    Sentry.captureMessage(`Missing mandatory fields: ${missingFields.join(', ')}`);
                    Sentry.captureMessage(`Facility: ${this.facility.id} - ${this.facility.name}`);
                    this.missingFields = missingFields;
                    return true;
                }

                return false;
            });
        },

        isNoEmailsDuplicates(results) {
            const seenEmails = new Map();
            this.emailDuplicates = [];

            results.data.forEach((raw, index) => {
                const rawValues = this.getRawValues(raw);
                const email = rawValues.familyMemberNameEmail;

                if (!email) {
                    return;
                }

                if (seenEmails.has(email)) {
                    this.emailDuplicates.push(index);

                    // Also store the first occurrence index if it's not already in emailDuplicates
                    if (!this.emailDuplicates.includes(seenEmails.get(email))) {
                        this.emailDuplicates.push(seenEmails.get(email));
                    }
                }
                else {
                    seenEmails.set(email, index);
                }
            });

            this.emailDuplicates = this.emailDuplicates.sort((a, b) => a - b)

            return this.emailDuplicates.length === 0;
        },

        selectResident(){
            this.selectedResident = this.residents.find(x=>x.id == this.residentId)
        },

        getRawValues(raw) {

            const data = {
                residentName: undefined,
                familyMemberName: undefined,
                familyMemberNameEmail: undefined,
                relationship: '',
                phoneNumber: '',
                addToApp: undefined,
                epoa: undefined,
                isWelfarePOA: undefined,
                isEnduringPOA: undefined,
                isCanInvite: undefined,
                residentConsent: undefined,
                careSummary: undefined,
                dailyCare: undefined,
                dailyPlan: undefined,
                carePlan: undefined,
                concierge: undefined,
                instantCalls: undefined,
                scheduledCalls: undefined,
                chat: undefined
            }

            for (const key of Object.keys(raw)) {
                const value = raw[key] && typeof raw[key] === 'string' ? raw[key].trim():raw[key]

                if (key === this.csvHeaders.residentName) {
                    data.residentName = value;
                } else if (key === this.csvHeaders.familyMemberName) {
                    data.familyMemberName = value;
                } else if (key === this.csvHeaders.familyMemberNameEmail) {
                    data.familyMemberNameEmail = value;
                } else if (key === this.csvHeaders.relationship) {
                    data.relationship = value;
                } else if (key === this.csvHeaders.phoneNumber) {
                    data.phoneNumber = value;
                } else if (key === this.csvHeaders.addToApp) {
                    data.addToApp = (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') ? (value.toLowerCase() === 'true') : undefined;
                } else if (key === this.csvHeaders.epoa) {
                    data.epoa = toBoolean(value)
                } else if (key === this.csvHeaders.isWelfarePOA) {
                    data.isWelfarePOA = toBoolean(value)
                } else if (key === this.csvHeaders.isEnduringPOA) {
                    data.isEnduringPOA = toBoolean(value)
                }  else if (key === this.csvHeaders.isCanInvite) {
                    data.isCanInvite = (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') ? (value.toLowerCase() === 'true') : undefined;
                } else if (key === this.csvHeaders.residentConsent) {
                    data.residentConsent = (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') ? (value.toLowerCase() === 'true') : undefined;
                } else if (key === this.csvHeaders.careSummary) {
                    data.careSummary = (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') ? (value.toLowerCase() === 'true') : undefined;
                } else if (key === this.csvHeaders.dailyCare) {
                    data.dailyCare = (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') ? (value.toLowerCase() === 'true') : undefined;
                } else if (key === this.csvHeaders.dailyPlan) {
                    data.dailyPlan = (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') ? (value.toLowerCase() === 'true') : undefined;
                } else if (key === this.csvHeaders.carePlan) {
                    data.carePlan = (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') ? (value.toLowerCase() === 'true') : undefined;
                } else if (key === this.csvHeaders.concierge) {
                    data.concierge = (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') ? (value.toLowerCase() === 'true') : undefined;
                } else if (key === this.csvHeaders.instantCalls) {
                    data.instantCalls = (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') ? (value.toLowerCase() === 'true') : undefined;
                } else if (key === this.csvHeaders.concierge) {
                    data.concierge = (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') ? (value.toLowerCase() === 'true') : undefined;
                } else if (key === this.csvHeaders.scheduledCalls) {
                    data.scheduledCalls = (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') ? (value.toLowerCase() === 'true') : undefined;
                } else if (key === this.csvHeaders.chat) {
                    data.chat = (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') ? (value.toLowerCase() === 'true') : undefined;
                }
            }

            return data
        },

        toggleFinancialEPOA(){

            if(this.isFinancialEPOA
                && this.$store.state.facilityModule.selectedFacility?.isEnableCareTab === true 
                && this.$store.state.facilityModule.selectedFacility?.isEnabledCarePlan){
                this.staffControlledFamilyAccesses.carePlan = false
            }
            this.financialEPOA = [{
                id: this.residentId,
                status: this.isFinancialEPOA
            }]
        },

        toggleWelfarePOA(){

            if(this.isWelfarePOA
                && this.$store.state.facilityModule.selectedFacility?.isEnableCareTab === true 
                && this.$store.state.facilityModule.selectedFacility?.isEnabledCarePlan){
                this.staffControlledFamilyAccesses.carePlan = false
            }

            this.welfarePOA = [{
                id: this.residentId,
                status: this.isWelfarePOA
            }]
        },

        toggleEnduringPOA(){

            if(this.isEnduringPOA
                && this.$store.state.facilityModule.selectedFacility?.isEnableCareTab === true 
                && this.$store.state.facilityModule.selectedFacility?.isEnabledCarePlan){
                this.staffControlledFamilyAccesses.care = true
                this.staffControlledFamilyAccesses.carePlan = true
            }
            else{
                this.staffControlledFamilyAccesses.carePlan = false
            }

            this.enduringPOA = [{
                id: this.residentId,
                status: this.isEnduringPOA
            }]
        },

        setError() {
            this.isError = true;
            this.filename = null;
            this.csv = null;
            this.$refs.input?.focusout;
        },

        clearError() {
            this.isError = false;
            this.errorContent = "";
            this.errorHeaders = "";
            this.errorValues = "";
            this.errorEmails = "";
        },

        setErrorContent(errorContent) {
            if (errorContent) {
                this.errorContent = `${this.errorContent} <br/> ${errorContent}`;
            }
            this.setError();
        },

        setErrorHeaders(errorHeaders) {
            this.errorHeaders = `<br/> ${errorHeaders}`;
            this.setError();
        },

        setErrorValues(errorValues) {
            this.errorValues = `<br/> ${errorValues}`;
            this.setError();
        },

        setErrorEmails(errorEmails) {
            this.errorEmails = `<br/> ${errorEmails}`;
            this.setError();
        },

        close() {
            this.submited = false;
            if (this.$refs.form) {
                this.$refs.form.reset()
                this.rule = null
            }
            this.open = false
        }

    }
};